import React, { PureComponent } from 'react';
import './ReOrder.scss';

class ReOrder extends PureComponent {
  fireGA(productData, userInfo, view) {
    const trackEnv = view === 'desktop' ? 'dtm' : 'mobileGA';
    if (window[trackEnv].LenskartRewamp) {
      const lenskartPrice =
        productData.catalogPrices[1] && productData.catalogPrices[1].name === 'Lenskart Price'
          ? productData.catalogPrices[1].value
          : '';
      window.sessionStorage.isReOrderProduct = 'ON';
      const reOrderBtnDtmObj = location.pathname.includes('order-detail')
        ? {
            ctaname: 'OrderDetail | ReOrder',
            channel: 'OrderDetail | ' + productData.productType + ' | ' + productData.productId,
          }
        : {
            ctaname: 'orderListing | ReOrder',
            channel: 'OrderListing | ' + productData.productType + ' | ' + productData.productId,
          };
      window[trackEnv].LenskartRewamp.myaccount.reOrderAndDetailClick(reOrderBtnDtmObj);
      window[trackEnv].LenskartRewamp.myaccount.ecommproductBuyAgain(
        productData,
        lenskartPrice,
        'loggedIn',
        'productClick'
      );
    }
    if (typeof window.clevertap !== 'undefined') {
      if (location.pathname.includes('order-detail')) {
        window.clevertap.event.push('Reorder_MyOrderPage', {
          userId: userInfo.telephone,
          ProductID: productData.productId,
        });
      } else {
        window.clevertap.event.push('Reorder_ViewOrderPage', {
          userId: userInfo.telephone,
          ProductID: productData.productId,
        });
      }
    }
  }
  render() {
    const { view, item, userInfo, dataLocale, localeInfo } = this.props;
    const { REORDER_IN_2_MIN, CUSTOMER_SUPPORT_NUMBER, POWER_SUBMITTED, REORDER } = dataLocale;
    const { domain } = localeInfo;
    return (
      <div
        className="reorder-wrapper reorder-view power-expand margin-l20 margin-r20 margin-t25"
        data-testid="reorderWrapper"
      >
        <div
          className={`${view === 'desktop' ? 'width100 padding-t10 padding-b10' : 'w100'} shadow`}
        >
          <div className="reorder-view display-flex justify-space-between pd-12 align-items-center">
            <div className="msg-container">
              <div className="fw700 fs16 margin-b2">{REORDER_IN_2_MIN}</div>
              <span>
                <a
                  aria-label="Click here to call customer support"
                  className={`${
                    view === 'desktop'
                      ? 'fs14 text-color-primary no-decoration'
                      : 'text-color_link_blue'
                  } fw700 no-wrap`}
                  href={`tel:${CUSTOMER_SUPPORT_NUMBER}`}
                >
                  {CUSTOMER_SUPPORT_NUMBER}
                </a>
              </span>
            </div>
            <div className="buy-btn-container">
              <a
                aria-label="Click here to reorder same product"
                className={`btn unactive buy-again-btn fw700 ${
                  view === 'desktop'
                    ? 'fs14 margin-t5 margin-b5 text-color-white bg-color-primary width120'
                    : 'text-color_white bg-color_link_blue border-blue'
                }`}
                href={item.productUrl?.replace('https://www.lenskart.com', '').replace(domain, '')}
                rel="noreferrer"
                target={`${view === 'desktop' ? '_blank' : '_self'}`}
                onClick={this.fireGA.bind(this, item, userInfo, view)}
              >
                {REORDER}
              </a>
            </div>
          </div>
        </div>
        <div
          className={`power-submit-list ${
            view === 'desktop' ? 'padding-b10 fs12 ' : ' pd-l15 pd-r15 pd-b10'
          }`}
        >
          <div className="headings shadow">
            {item.frameWidth && (
              <span
                className={`inline-block ${
                  view === 'desktop' ? 'margin-r25 margin-l10 fw700' : 'mr-r25'
                }`}
                data-testid="frameWidth"
              >
                <i
                  className={`fa fa-check icon-checked ${
                    view === 'desktop' ? 'fs16 margin-r4' : 'mr-r5'
                  }`}
                ></i>{' '}
                {`Size - ${item.frameWidth}`}{' '}
              </span>
            )}
            {item.powerRequired === 'POWER_SUBMITTED' &&
              item.prescription &&
              ((item.prescription.left && Object.keys(item.prescription.left).length > 0) ||
                (item.prescription.right && Object.keys(item.prescription.right).length > 0)) && (
                <span
                  className={`${view === 'desktop' ? 'margin-r25 fw700' : ''} inline-block`}
                  data-testid="powerSubmitted"
                >
                  <i className="fa fa-check icon-checked fs16 margin-r4 mr-r5"></i>{' '}
                  {POWER_SUBMITTED}
                </span>
              )}
          </div>
        </div>
      </div>
    );
  }
}

export default ReOrder;
